"use client";

import Link from "next/link";
import { TrendingUp } from "lucide-react";
import { motion } from "framer-motion";

const categoryLinks = [
    { label: "Data & BI",       href: "/courses?category=data-bi" },
    { label: "Programming",     href: "/courses?category=programming" },
    { label: "Cloud & ERP",     href: "/courses?category=cloud-erp" },
    { label: "Healthcare IT",   href: "/courses?category=healthcare" },
    { label: "Cybersecurity",   href: "/courses?category=cybersecurity" },
    { label: "Project Mgmt",    href: "/courses?category=project-management" },
    { label: "Networking",      href: "/courses?category=networking" },
    { label: "QA & Testing",    href: "/courses?category=qa-testing" },
];

export function StatsBar() {
    return (
        <section className="py-6 bg-white border-b border-gray-50 overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-4 md:px-8 lg:px-12">
                <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
                    {/* Title */}
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="flex-shrink-0"
                    >
                        <h2 className="text-[#1A1A1A] font-bold text-lg md:text-md leading-tight tracking-tight">
                            Learn Skills That<br />Shape Your Future
                        </h2>
                    </motion.div>

                    {/* Scrolling Tags Container */}
                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                        className="flex-grow overflow-x-auto no-scrollbar"
                    >
                        <div className="flex items-center gap-3 py-1">
                            {categoryLinks.map((item) => (
                                <Link
                                    key={item.href}
                                    href={item.href}
                                    className="flex items-center gap-2.5 px-4 py-2.5 bg-[#F3F5F7] hover:bg-[#E9ECEF] transition-colors rounded-full whitespace-nowrap group"
                                >
                                    <TrendingUp className="w-4 h-4 text-[#4B6BFB] group-hover:scale-110 transition-transform" />
                                    <span className="font-semibold text-[#343A40] text-[13px] md:text-[12px]">{item.label}</span>
                                </Link>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
